import { Controller } from "stimulus"
import $ from 'jquery'
import Sortable from 'sortablejs'

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      draggable: '[data-id]',
      handle: '.grabbable',
      onEnd: this.end.bind(this)
    })
  }

  end(e) {
    const id = e.item.dataset.id
    const data = new FormData()
    data.append("position", e.newIndex + 1)

    $.ajax({
      url: this.data.get("url").replace(":id", id),
      beforeSend: xhr => xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')),
      type: 'PATCH',
      data: data,
      processData: false,
      contentType: false
    })
  }
}